import React, { useState } from "react";
import { ArrowLeft, Lock } from "lucide-react";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import FeatureHeader from "../components/FeatureHeader";
export default function ForgotPasswordReset() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email: email.trim() });
      navigate('/reset-confirmation', { state: { email: email.trim() } });
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
  <div style={{ minHeight: "100vh",  alignItems: "center", padding: "24px 16px", background: "var(--bg)", position: "relative" }}>
      {/* Back Button */}
      <FeatureHeader title = "Forgot Password" subtitle = "Please enter your recovery email to reset your password" onBack={() => navigate(-1)} />

      {/* Card */}
      <div style={{ width: "70%", marginLeft: "15%", marginTop : "60px", borderRadius: "22px", background: "#fff", border: "1px solid #ececf5", boxShadow: "0 12px 36px rgba(80, 0, 200, 0.09)", padding: "32px 28px", textAlign: "center" }}>
        {/* Logo & Icon */}
        <div className="mb-4">
          <div style = {{width : "20%", marginLeft : "40% "}}>
          <img src={logo} alt="Logo" style={{ width: "64px" }} />
          </div>
          <div className="d-flex justify-content-center align-items-center mt-3" style={{ width: "80px", height: "80px", borderRadius: "50%", margin: "0 auto", background: "color-mix(in srgb, var(--primary) 12%, white)" }}>
            <Lock size={35} color="var(--primary)" />
          </div>
        </div>

        {/* Text */}
        <h5 className="mt-4 fw-semibold" style={{ color: "#171b2d", fontSize: "22px" }}>Forgot your password?</h5>
        <p style={{ color: "#73798a", marginBottom: "1rem", fontSize: "0.9em", lineHeight: 1.5 }}>
          Don’t worry! Enter your recovery email, and we’ll send you a link to reset it.
        </p>

        {/* Email Input */}
        <form className="text-start mb-3" onSubmit={handleSubmit}>
          <label className="fw-semibold mb-1" style={{ color: "#2f374d", fontSize: 13 }}>Recovery Email</label>
          <input type="email" placeholder="example@mail.com" className="form-control" style={{ border: "1px solid #e4e5ee", borderRadius: 10, padding: "12px", outlineColor: "var(--primary)" }} value={email} onChange={(event) => setEmail(event.target.value)} required />
          {error && <div className="text-danger mt-2" role="alert">{error}</div>}

          <button type="submit" className="btn w-100 mt-3 " disabled={loading} style={{ padding: "12px", background : "var(--primary)", color: "#fff", borderRadius: "10px", fontWeight: "600" }}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {/* Contact Us */}
        <p style={{ color: "var(--muted)", marginTop: "1rem", fontSize: "0.9em" }}>
          Can't remember your email?{" "}
          <a href="#!" className="accent" style={{ fontWeight: "600" }}>
            Contact us
          </a>
        </p>
      </div>
    </div>
  );
}
